
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-088121db\",\"scoped\":true,\"hasInlineConfig\":false}!@../../../static/css/dialogEntry.css")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./crmCustomerdialog.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-088121db\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./crmCustomerdialog.vue"),
  /* scopeId */
  "data-v-088121db",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/crmDialog/crmCustomerdialog.vue
// module id = 1735
// module chunks = 0